<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Locação de Vagas
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Locação de Vagas
              li.breadcrumb-item.active Cadastro
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                placeholder='Localizar Unidade',
                disabled
              )
              span.input-group-addon
                i.zmdi.zmdi-search


      .row.clearfix
        .col-lg-12
          .card
            .header
              ul.header-dropdown
                li.dropdown(:class="{'show': show}")
                  a.dropdown-toggle(@click.prevent="showActions(show)", href='javascript:void(0);')
                    i.zmdi.zmdi-more
                  ul.dropdown-menu.dropdown-menu-right(:class="{'show': show}")
                    li
                      router-link(:to="{name: 'tenant.rent.parking.index'}") Listagem
                    li
                     router-link(:to="{name: 'tenant.rent.parking.create'}") Cadastro
            .body
              h2.card-inside-title Dados do Carro
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rent.tower_id.$error ? 'error' : null")
                      f-select(
                        id="unit_id",
                        name="tower",
                        track-by="id",
                        label-by="number",
                        v-model="rent.tower_id",
                        :options="dwellerTowers",
                        :searchable="true",
                        :multiple="false",
                         placeholder='Selecionar Torre',
                        @selected ="selectUnitsTower"
                        openDirection="bottom"
                      )

                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rent.unit_id.$error ? 'error' : null")
                      f-select(
                        id="unit_id",
                        name="Unidade",
                        track-by="id",
                        placeholder="Selecionar Unidade"
                        label-by="number",
                        v-model="rent.unit_id",
                        :options="dwellerUnits",
                        :searchable="true",
                        :multiple="false",
                        @selected="getGaragesDweller"
                        openDirection="bottom"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.rent.garage_id.$error ? 'error' : null")
                        f-select(
                          id="garage_id",
                          placeholder="Garagem"
                          track-by="id",
                          label="Selecionar Garagem",
                          label-by="number",
                          v-model="rent.garage_id",
                          :options="garages",
                          :searchable="true",
                          :multiple="false",
                          openDirection="bottom"
                        )
              h2.card-inside-title Informe a placa do carro
              .row.clearfix
                .col-lg-4.col-md-4
                 v-input(:status="$v.rent.car_id.$error ? 'error' : null")
                  f-select-car(
                    id="car-id",
                    name="car-id",
                    v-model="rent.car_id",
                    label-by="plate",
                    :searchable="true",
                    style="margin-top: -30px;"
                  )
              h2.card-inside-title Período de Aluguel
              .row.clearfix
                .col-sm-6
                  .form-group
                    v-input(:status="$v.rent.date_go_in.$error ? 'error' : null")
                      label Data Inicial
                      vue-ctk-date-time-picker(
                        color="#7159c1",
                        v-model="rent.date_go_in",
                        no-label,
                        :no-header="false"
                        label="Selecione uma data"
                        :only-date="true"
                        locale="pt-br",
                        :format="'YYYY-MM-DD'",
                        :min-date="minDate",
                        :auto-close="true",
                        :no-keyboard="false",
                        button-now-translation="Hoje"
                      )
                .col-sm-6
                  .form-group
                    v-input(:status="$v.rent.date_go_out.$error ? 'error' : null")
                      label Data Final
                      vue-ctk-date-time-picker(
                        color="#7159c1",
                        v-model="rent.date_go_out",
                        no-label,
                        :no-header="false"
                        label="Selecione uma data"
                        :only-date="true"
                        locale="pt-br",
                        :format="'YYYY-MM-DD'",
                        :min-date="minDate",
                        :auto-close="true",
                        :no-keyboard="false",
                        button-now-translation="Hoje"
                      )
                .col-md-12
                    button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                      type='button',
                      @click.prevent="doSave()",
                    ) Salvar

</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/rent-parking/form/form.vue